"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiPlaceholderConfigurationPanel = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var model_1 = require("../../../model");
var sizing_1 = require("../../../_staging/layout/sizing");
var KpiConfigurationPanelCore_1 = require("../kpi/DefaultKpiConfigurationPanel/KpiConfigurationPanelCore");
exports.KpiPlaceholderConfigurationPanel = function (props) {
    var widget = props.widget, onClose = props.onClose;
    var dispatch = model_1.useDashboardDispatch();
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var measuresMap = model_1.useDashboardSelector(model_1.selectAllCatalogMeasuresMap);
    var _a = model_1.useDashboardSelector(model_1.selectWidgetCoordinatesByRef(widget.ref)), itemIndex = _a.itemIndex, sectionIndex = _a.sectionIndex;
    var replaceKpiProcessing = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.replaceSectionItem,
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        successEvent: "GDC.DASH/EVT.FLUID_LAYOUT.ITEM_REPLACED",
        onSuccess: function (event) {
            var ref = event.payload.items[0].widget.ref;
            dispatch(model_1.uiActions.selectWidget(ref));
            dispatch(model_1.uiActions.setConfigurationPanelOpened(true));
        },
    });
    var handleMeasureChanged = react_1.useCallback(function (measureRef) {
        var measure = measuresMap.get(measureRef);
        ts_invariant_1.default(measure, "Invalid measure when creating a KPI");
        var sizeInfo = sizing_1.getSizeInfo(settings, "kpi");
        // replace the placeholder that is already in place
        replaceKpiProcessing.run(sectionIndex, itemIndex, {
            type: "IDashboardLayoutItem",
            size: {
                xl: {
                    gridHeight: sizeInfo.height.default,
                    gridWidth: sizeInfo.width.default,
                },
            },
            widget: {
                type: "kpi",
                description: "",
                drills: [],
                ignoreDashboardFilters: [],
                kpi: {
                    comparisonType: "previousPeriod",
                    metric: measureRef,
                    comparisonDirection: "growIsGood",
                },
                title: measure.measure.title,
                dateDataSet: undefined,
            },
        });
    }, [measuresMap, settings, replaceKpiProcessing, sectionIndex, itemIndex]);
    return react_1.default.createElement(KpiConfigurationPanelCore_1.KpiConfigurationPanelCore, { onMeasureChange: handleMeasureChanged, onClose: onClose });
};
//# sourceMappingURL=KpiPlaceholderConfigurationPanel.js.map